var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { classNames } from '@progress/kendo-react-common';
import * as React from 'react';
/**
 * Represents the KendoReact InputPrefix component.
 */
export var InputPrefix = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var target = React.useRef(null);
  var element = React.useRef(null);
  React.useImperativeHandle(target, function () {
    return {
      element: element.current
    };
  });
  React.useImperativeHandle(ref, function () {
    return target.current;
  });
  return /*#__PURE__*/React.createElement("span", __assign({}, props, {
    className: classNames('k-input-prefix', props.className)
  }));
});
InputPrefix.displayName = 'KendoReactInputPrefix';